import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import cache from "utils/cache";

const baseUrl = process.env.REACT_APP_BASE_URL;

const ALLOWED_LOGIN_ROLES = ["DROPSHIPPER", "SUPPLIER"];

export const handle401Error = async () => {
  console.log("handle401Error called!");
  // Rest of your middleware logic
};

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(handle401Error),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "auth/login-v1",
        method: "POST",
        body: credentials,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const loggedInUser = data?.user;
          if (loggedInUser && ALLOWED_LOGIN_ROLES.includes(loggedInUser.role)) {
            cache.setItem("user", loggedInUser);
            dispatch(
              authApi.util.upsertQueryData("verifyUser", undefined, loggedInUser)
            );
          }
        } catch {
          // Login failed — keep existing verify/session state.
        }
      },
    }),
    signUp: builder.mutation({
      query: (credentials) => ({
        url: "auth/register",
        method: "POST",
        body: credentials,
      }),
    }),
    verifyUser: builder.query({
      query: () => "auth",
    }),
    logoutUser: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "POST",
      }),
    }),
    updateDropshipper: builder.mutation({
      query: (payload) => ({
        url: "users/updateDropshipper",
        method: "POST",
        body: payload,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const updatedUser = data?.user;
          if (updatedUser) {
            cache.setItem("user", updatedUser);
            dispatch(
              authApi.util.updateQueryData("verifyUser", undefined, (draft) => ({
                ...(draft ?? {}),
                ...updatedUser,
                firstTimeLogin: updatedUser.firstTimeLogin ?? false,
              }))
            );
          }
        } catch {
          // Onboarding failed — keep existing verify/session state.
        }
      },
    }),
    getShippingAddress: builder.query({
      query: () => `users/shippingAddress`,
    }),
    addShippingAddress: builder.mutation({
      query: (payload) => ({
        url: "users/shippingAddress",
        method: "POST",
        body: payload,
      }),
    }),
    updateProfile: builder.mutation({
      query: (payload) => ({
        url: "users/updateProfile",
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSignUpMutation,
  useVerifyUserQuery,
  useLogoutUserMutation,
  useUpdateDropshipperMutation,
  useGetShippingAddressQuery,
  useAddShippingAddressMutation,
  useUpdateProfileMutation,
} = authApi;
